export default __webpack_public_path__ + "static/media/eb-pro-blk-banner-3.52d1a4a7.jpg";